import React from "react";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import classNames from "classnames";
import Modal from "@tvg/ui-bootstrap/components/Modal";
import style from "./utils.css";

const getRootElement = (id) => {
  let element = document && document.getElementById(id);

  if (!element) {
    element = document.createElement("div");
    element.id = id;
    document.body.appendChild(element);
  }

  return element;
};

const openModal = (id, content, customModal = false, callback) => {
  const rootElement = getRootElement(id);
  unmountComponentAtNode(rootElement);

  const modalStyle = classNames({
    [style.loginModal]: true,
    [style.customModal]: customModal
  });

  return ReactDOM.render(
    // eslint-disable-line
    <Modal autoOpen classnames={modalStyle} modalIdentifier={id}>
      {content}
    </Modal>,
    rootElement,
    callback
  );
};

export default {
  getRootElement,
  openModal
};
